import GeckoRequest from 'services/gecko-request';
import GeckoStore from '../gecko-store';
import GeckoPermissions from 'services/gecko-permissions';

const setupIntercom = async () => {
  const intercomData = await GeckoRequest.get('/user/intercom_data');
  window.Intercom('boot', {
    app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    ...intercomData,
  });
};

const SetupWidgets = (region) => {
  const loggedInUser = GeckoStore.redux.get('appState.loggedInUser');
  const loggedInAccount = GeckoStore.redux.get('appState.account');
  const userGroup = GeckoPermissions.getUserGroup();

  let accountPromise;

  if (loggedInAccount && !accountPromise) {
    accountPromise = Promise.resolve(loggedInAccount);
  } else if (!loggedInAccount && !accountPromise) {
    accountPromise = GeckoRequest.get('/account');
  }

  accountPromise.then((account) => {
    setupIntercom().catch((error) => {
      console.error('Failed to set up intercom', error);
    });

    if (process.env.NODE_ENV === 'production') {
      window.pendo.initialize({
        visitor: {
          id: `chat_${region}_${loggedInUser.account_id}_${loggedInUser.id}`,
          name: loggedInUser.full_name,
          full_name: loggedInUser.full_name,
          email: loggedInUser.email,
          phone: loggedInUser.tel,
          company: account.name,
          chat_user_group: userGroup,
          chat_account_id: account.id,
        },
        account: {
          id: `chat_${region}_${account.id}`,
          name: account.name,
        },
      });
    }

    try {
      if (!window.receptiveAppSettings) {
        window.receptiveAppSettings = {
          timestamp: new Date().toISOString(),
          return_url: decodeURI(window.location.href),
          account: {
            id: `chat_${region}_${account.id}`,
            name: account.name,
            is_paying: true,
          },
          vendor: {
            id: '9eef2f2b-b969-4f0e-a570-cca1022671ec',
          },
          user: {
            id: `chat_${region}_${loggedInUser.account_id}_${loggedInUser.id}`,
            email: loggedInUser.email,
            full_name: loggedInUser.full_name,
          },
          feature: {
            tags: ['GeckoChat'],
          },
        };
        let widgetScript = document.createElement('script');
        widgetScript.type = 'text/javascript';
        widgetScript.async = true;
        widgetScript.src = 'https://receptive.io/js/widget/widget.js';
        document.head.appendChild(widgetScript);
      }
    } catch (err) {
      console.error('Receptive Error', err);
    }
  });
};

export default SetupWidgets;
